import React from 'react';
import ApprovalInterface from './ApprovalInterface';

const Approvals: React.FC = () => {
  return (
    <div className="h-full">
      <ApprovalInterface className="h-full" />
    </div>
  );
};

export default Approvals;
